import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Sidebar from '../components/Sidebar';
import background2 from '../assets/background2.png';
import icon_edit from '../assets/icon_edit.png';
import FollowingIcon from '../assets/FollowingIcon.png';
import icondone from '../assets/icondone.png';
import instagram_icon from '../assets/instagram2.png';
import twitter1 from '../assets/twitter1.png';
import twitter2 from '../assets/twitter2.png';
import discord_icon from '../assets/discord2.png';
import mail2 from '../assets/mail2.png';
import coin from '../assets/coin.png';
import group45 from '../assets/group45.png';
import group76 from '../assets/group76.png';
import question from '../assets/question.png';
import warning_sign from '../assets/warning_sign.png';
import copy from '../assets/copy.png';
import rectangle73 from '../assets/rectangle73.png';
import { 
  ProfileNameModal, 
  InstagramModal, 
  TwitterModal, 
  DiscordModal, 
  BioModal,
  BackgroundImageModal,
  ProfileImageModal
} from './SettingsModals';

export default function SettingsPage() {
  const { user, updateProfile } = useAuth();
  
  const [avatarPreview, setAvatarPreview] = useState(user?.avatar || '');
  const [isProfileNameModalOpen, setIsProfileNameModalOpen] = useState(false);
  const [isInstagramModalOpen, setIsInstagramModalOpen] = useState(false);
  const [isTwitterModalOpen, setIsTwitterModalOpen] = useState(false);
  const [isDiscordModalOpen, setIsDiscordModalOpen] = useState(false);
  const [isBioModalOpen, setIsBioModalOpen] = useState(false);
  const [isProfileImageModalOpen, setIsProfileImageModalOpen] = useState(false);
  const [isBackgroundImageModalOpen, setIsBackgroundImageModalOpen] = useState(false);
  const [backgroundImagePreview, setBackgroundImagePreview] = useState(user?.backgroundPhoto || '');

  const handleSaveNickname = async (newNickname) => {
    await updateProfile({ nickname: newNickname });
  };

  const handleSaveInstagram = async (instagram) => {
    console.log('💾 Сохранение Instagram:', instagram);
    await updateProfile({ instagram });
  };

  const handleSaveTwitter = async (twitter) => {
    console.log('💾 Сохранение Twitter:', twitter);
    await updateProfile({ twitter });
  };

  const handleSaveDiscord = async (discord) => {
    console.log('💾 Сохранение Discord:', discord);
    await updateProfile({ discord });
  };

  const handleSaveBio = async (bio) => {
    console.log('💾 Сохранение Bio:', bio);
    await updateProfile({ bio });
  };

  const handleSaveProfileImage = async (image) => {
    console.log('💾 Сохранение Profile Image:', image);
    // Если это файл, создаем data URL, иначе используем как есть
    let imageData = image;
    if (image instanceof File) {
      const reader = new FileReader();
      reader.onloadend = async () => {
        const result = await updateProfile({ avatar: reader.result });
        if (result.success) {
          setAvatarPreview(reader.result);
        }
      };
      reader.readAsDataURL(image);
    } else {
      const result = await updateProfile({ avatar: imageData });
      if (result.success) {
        setAvatarPreview(imageData);
      }
    }
  };

  const handleSaveBackgroundImage = async (image) => {
    console.log('💾 Сохранение Background Image:', image);
    // Если это файл, создаем data URL, иначе используем как есть
    let imageData = image;
    if (image instanceof File) {
      const reader = new FileReader();
      reader.onloadend = async () => {
        const result = await updateProfile({ backgroundPhoto: reader.result });
        if (result.success) {
          setBackgroundImagePreview(reader.result);
        }
      };
      reader.readAsDataURL(image);
    } else {
      const result = await updateProfile({ backgroundPhoto: imageData });
      if (result.success) {
        setBackgroundImagePreview(imageData);
      }
    }
  };

  // Обновляем preview при изменении user
  useEffect(() => {
    if (user?.backgroundPhoto) {
      setBackgroundImagePreview(user.backgroundPhoto);
    }
    if (user?.avatar) {
      setAvatarPreview(user.avatar);
    }
  }, [user?.backgroundPhoto, user?.avatar]);

  return (
    <div className="h-screen bg-[#1E1E1E] text-white flex flex-col overflow-hidden">
      {/* Modals */}
      <ProfileNameModal 
        isOpen={isProfileNameModalOpen}
        onClose={() => setIsProfileNameModalOpen(false)}
        currentNickname={user?.nickname}
        onSave={handleSaveNickname}
      />

      <InstagramModal 
        isOpen={isInstagramModalOpen}
        onClose={() => setIsInstagramModalOpen(false)}
        currentInstagram={user?.instagram}
        onSave={handleSaveInstagram}
      />

      <TwitterModal 
        isOpen={isTwitterModalOpen}
        onClose={() => setIsTwitterModalOpen(false)}
        currentTwitter={user?.twitter}
        onSave={handleSaveTwitter}
      />

      <DiscordModal 
        isOpen={isDiscordModalOpen}
        onClose={() => setIsDiscordModalOpen(false)}
        currentDiscord={user?.discord}
        onSave={handleSaveDiscord}
      />

      <BioModal 
        isOpen={isBioModalOpen}
        onClose={() => setIsBioModalOpen(false)}
        currentBio={user?.bio}
        onSave={handleSaveBio}
      />

      <ProfileImageModal 
        isOpen={isProfileImageModalOpen}
        onClose={() => setIsProfileImageModalOpen(false)}
        currentImage={user?.avatar || avatarPreview}
        onSave={handleSaveProfileImage}
      />

      <BackgroundImageModal 
        isOpen={isBackgroundImageModalOpen}
        onClose={() => setIsBackgroundImageModalOpen(false)}
        currentImage={user?.backgroundPhoto || backgroundImagePreview}
        onSave={handleSaveBackgroundImage}
      />
      <Header />


      <div className="flex flex-1 overflow-hidden">
        <Sidebar activePage="profile" />

        {/* Main Content */}
        <main className="flex-1 bg-[#141414] flex flex-col overflow-hidden">
          <div className="flex-1 overflow-y-auto overflow-x-hidden">
            <div className="relative">
              {/* Background Image */}
              <div 
                className="relative"
                style={{
                  width: '100%',
                  height: 'clamp(200px, 20.83vw, 400px)',
                  borderBottom: '4px solid #8F0A0A'
                }}
              >
                <img 
                  src={backgroundImagePreview || background2} 
                  alt="Background"
                  className="w-full h-full object-cover"
                />

                {/* Settings Label */}
                <div
                  className="absolute flex items-center justify-center"
                  style={{
                    left: 0,
                    top: 0,
                    width: 'clamp(55px, 5.73vw, 110px)',
                    height: 'clamp(20px, 2.08vw, 40px)',
                    backgroundColor: '#000000',
                    fontFamily: 'Keania One',
                    fontWeight: 400,
                    fontSize: 'clamp(9px, 0.94vw, 18px)',
                    color: '#FFFFFF',
                    borderBottomRightRadius: '10px'
                  }}
                >
                  Settings
                </div>

                {/* Avatar Circle */}
                <div
                  className="absolute rounded-full border-4 border-[#E10000] overflow-hidden flex items-center justify-center bg-[#2A2A2A]"
                  style={{
                    left: 'clamp(55px, 5.73vw, 110px)',
                    top: 'clamp(65px, 6.77vw, 130px)',
                    width: 'clamp(70px, 7.29vw, 140px)',
                    height: 'clamp(70px, 7.29vw, 140px)'
                  }}
                >
                  {avatarPreview ? (
                    <img 
                      src={avatarPreview} 
                      alt="Avatar" 
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                      style={{
                        width: '60%',
                        height: '60%',
                        color: '#E10000'
                      }}
                    >
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                  )}
                </div>

                {/* Edit Avatar Button */}
                <button
                  onClick={() => setIsProfileImageModalOpen(true)}
                  className="absolute flex items-center justify-center cursor-pointer hover:opacity-90 transition-opacity"
                  style={{
                    left: 'clamp(62px, 6.46vw, 124px)',
                    top: 'clamp(143.5px, 14.95vw, 287px)',
                    width: 'clamp(55px, 5.73vw, 110px)',
                    height: 'clamp(17.5px, 1.82vw, 35px)',
                    backgroundColor: '#4E86D3',
                    borderRadius: '4px',
                    fontFamily: 'Keania One',
                    fontWeight: 400,
                    fontSize: 'clamp(7px, 0.73vw, 14px)',
                    color: 'rgba(255, 255, 255, 0.8)',
                    paddingLeft: 'clamp(12px, 1.25vw, 24px)',
                    border: 'none'
                  }}
                >
                  <img 
                    src={icon_edit}
                    alt="Edit"
                    style={{
                      position: 'absolute',
                      left: 'clamp(8px, 0.73vw, 14px)',
                      top: 'clamp(5.5px, 0.57vw, 11px)',
                      width: 'clamp(6px, 0.63vw, 12px)',
                      height: 'clamp(6px, 0.63vw, 12px)',
                      opacity: 0.7
                    }}
                  />
                  Edit Avatar
                </button>

                {/* Account Status - Right Side */}
                <div
                  className="absolute flex items-center justify-center border"
                  style={{
                    left: 'clamp(641px, 66.77vw, 1282px)',
                    top: 'clamp(25.5px, 2.66vw, 51px)',
                    width: 'clamp(76px, 7.92vw, 152px)',
                    height: 'clamp(20px, 2.08vw, 40px)',
                    backgroundColor: 'rgba(0, 222, 111, 0.15)',
                    borderColor: '#00DE6F',
                    fontFamily: 'Keania One',
                    fontWeight: 400,
                    fontSize: 'clamp(7px, 0.73vw, 14px)',
                    color: '#FFFFFF'
                  }}
                >
                  Account Status
                </div>

                {/* Collector Badge */}
                <div
                  className="absolute flex items-center justify-center"
                  style={{
                    left: 'clamp(717px, 74.69vw, 1434px)',
                    top: 'clamp(25.5px, 2.66vw, 51px)',
                    width: 'clamp(70px, 7.29vw, 140px)',
                    height: 'clamp(20px, 2.08vw, 40px)',
                    backgroundColor: '#00DE6F',
                    fontFamily: 'Keania One',
                    fontWeight: 400,
                    fontSize: 'clamp(7px, 0.73vw, 14px)',
                    color: '#FFFFFF'
                  }}
                >
                  Collector
                </div>

                {/* Profile Background Label */}
                <button
                  onClick={() => setIsBackgroundImageModalOpen(true)}
                  className="absolute flex items-center justify-center gap-2 cursor-pointer hover:opacity-90 transition-opacity"
                  style={{
                    left: 'clamp(355.5px, 37.03vw, 711px)',
                    top: 'clamp(180px, 18.75vw, 360px)',
                    width: 'clamp(120px, 12.5vw, 240px)',
                    height: 'clamp(20px, 2.08vw, 40px)',
                    backgroundImage: `url(${rectangle73})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    borderColor: '#830C0C',
                    fontFamily: 'Keania One',
                    fontWeight: 400,
                    fontSize: 'clamp(7px, 0.73vw, 14px)',
                    color: 'rgba(255, 255, 255, 0.6)'
                  }}
                >
                  Profile Background
                  <img 
                    src={FollowingIcon}
                    alt="Plus"
                    style={{
                      width: 'clamp(9px, 0.94vw, 18px)',
                      height: 'clamp(9px, 0.94vw, 18px)'
                    }}
                  />
                </button>
              </div>

              {/* Content Area Below Background */}
              <div 
                className="px-8 py-2 relative"
                style={{
                  minHeight: 'calc(100vh - 6.25vw - 20.83vw - 2.08vw)'
                }}
              >
                {/* Profile Name Section */}
                <div 
                  className="relative border"
                  style={{
                    width: 'clamp(200px, 20.83vw, 400px)',
                    height: 'clamp(50px, 5.21vw, 100px)',
                    marginLeft: 'clamp(51.5px, 5.36vw, 103px)',
                    marginTop: 'clamp(10px, 1.04vw, 20px)',
                    backgroundColor: '#212121',
                    borderColor: '#8F0A0A',
                    borderRadius: '6px'
                  }}
                >
                  {/* Profile Name Label */}
                  <div
                    style={{
                      position: 'absolute',
                      left: 'clamp(20px, 2.08vw, 40px)',
                      top: 'clamp(7.5px, 0.83vw, 16px)',
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(7px, 0.73vw, 14px)',
                      color: 'rgba(255, 255, 255, 0.6)'
                    }}
                  >
                    Profile Name
                  </div>

                  {/* Nickname Input Container */}
                  <div
                    className="absolute border"
                    style={{
                      width: 'clamp(120px, 12.5vw, 240px)',
                      height: 'clamp(17.5px, 1.82vw, 35px)',
                      left: 'clamp(13px, 1.35vw, 26px)',
                      top: 'clamp(18.5px, 1.93vw, 37px)',
                      backgroundColor: '#191919',
                      borderColor: '#790E0E',
                      borderRadius: '4px'
                    }}
                  >
                    {/* @ Symbol Container */}
                    <div
                      className="absolute flex items-center justify-center"
                      style={{
                        width: 'clamp(15px, 1.56vw, 30px)',
                        height: 'clamp(15.5px, 1.72vw, 33px)',
                        left: '0',
                        top: '0',
                        backgroundColor: '#790E0E',
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(8px, 0.83vw, 16px)',
                        color: '#FFFFFF'
                      }}
                    >
                      @
                    </div>

                    {/* Nickname Text */}
                    <div
                      className="absolute flex items-center"
                      style={{
                        left: 'clamp(21.5px, 2.24vw, 43px)',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(6px, 0.62vw, 12px)',
                        color: 'rgba(255, 255, 255, 0.8)'
                      }}
                    >
                      {user?.nickname || ''}
                    </div>

                    {/* Done Icon */}
                    {user?.nickname && (
                      <img
                        src={icondone}
                        alt="Done"
                        style={{
                          position: 'absolute',
                          width: 'clamp(9px, 0.94vw, 18px)',
                          height: 'clamp(9px, 0.94vw, 18px)',
                          right: 'clamp(5px, 0.52vw, 10px)',
                          top: '50%',
                          transform: 'translateY(-50%)'
                        }}
                      />
                    )}
                  </div>

                  {/* Change Button */}
                  <button
                    onClick={() => setIsProfileNameModalOpen(true)}
                    className="absolute hover:opacity-80 transition-opacity"
                    style={{
                      width: 'clamp(37.5px, 3.91vw, 75px)',
                      height: 'clamp(17.5px, 1.82vw, 35px)',
                      left: 'clamp(142px, 14.79vw, 284px)',
                      top: 'clamp(18.5px, 1.93vw, 37px)',
                      backgroundColor: '#5492E8',
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(6px, 0.62vw, 12px)',
                      color: '#FFFFFF',
                      border: 'none',
                      cursor: 'pointer',
                      borderRadius: '4px'
                    }}
                  >
                    Change
                  </button>
                </div>

                {/* Crypto Wallet Section - RIGHT SIDE */}
                <div 
                  className="absolute border"
                  style={{
                    width: 'clamp(200px, 20.83vw, 400px)',
                    height: 'clamp(50px, 5.21vw, 100px)',
                    left: 'clamp(289px, 30.1vw, 578px)',
                    top: 'clamp(15px, 1.56vw, 30px)',
                    backgroundColor: '#212121',
                    borderColor: '#8F0A0A',
                    borderRadius: '6px'
                  }}
                >
                  {/* Crypto Wallet Label */}
                  <div
                    style={{
                      position: 'absolute',
                      left: 'clamp(20px, 2.08vw, 40px)',
                      top: 'clamp(7.5px, 0.83vw, 16px)',
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(7px, 0.73vw, 14px)',
                      color: 'rgba(255, 255, 255, 0.6)'
                    }}
                  >
                    Crypto Wallet
                  </div>

                  {/* Wallet Input Container */}
                  <div
                    className="absolute border"
                    style={{
                      width: 'clamp(120px, 12.5vw, 240px)',
                      height: 'clamp(17.5px, 1.82vw, 35px)',
                      left: 'clamp(13px, 1.35vw, 26px)',
                      top: 'clamp(18.5px, 1.93vw, 37px)',
                      backgroundColor: '#191919',
                      borderColor: '#790E0E',
                      borderRadius: '4px'
                    }}
                  >
                    {/* Coin Icon Container */}
                    <div
                      className="absolute flex items-center justify-center"
                      style={{
                        width: 'clamp(15px, 1.56vw, 30px)',
                        height: 'clamp(15.5px, 1.72vw, 33px)',
                        left: '0',
                        top: '0',
                        backgroundColor: '#790E0E'
                      }}
                    >
                      <img
                        src={coin}
                        alt="Coin"
                        style={{
                          width: 'clamp(8px, 0.83vw, 16px)',
                          height: 'clamp(8px, 0.83vw, 16px)'
                        }}
                      />
                    </div>

                    {/* Wallet Text */}
                    <div
                      className="absolute flex items-center"
                      style={{
                        left: 'clamp(21.5px, 2.24vw, 43px)',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(6px, 0.62vw, 12px)',
                        color: 'rgba(255, 255, 255, 0.8)'
                      }}
                    >
                      2MqWH....zdT2NHHz
                    </div>

                    {/* Copy Icon */}
                    <img
                      src={copy}
                      alt="Copy"
                      style={{
                        position: 'absolute',
                        width: 'clamp(7px, 0.73vw, 14px)',
                        height: 'clamp(7px, 0.73vw, 14px)',
                        right: 'clamp(5px, 0.52vw, 10px)',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        cursor: 'pointer'
                      }}
                    />
                  </div>

                  {/* Warning Icon + Secured Text */}
                  <div
                    className="absolute flex items-center gap-1"
                    style={{
                      left: 'clamp(50px, 5.2vw, 100px)',
                      top: 'clamp(38px, 3.8vw, 73px)'
                    }}
                  >
                    <img
                      src={warning_sign}
                      alt="Warning"
                      style={{
                        width: 'clamp(7px, 0.73vw, 14px)',
                        height: 'clamp(7px, 0.73vw, 14px)'
                      }}
                    />
                    <div
                      style={{
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(5px, 0.52vw, 10px)',
                        color: 'rgba(255, 255, 255, 0.4)'
                      }}
                    >
                      Make sure your wallet is secured
                    </div>
                  </div>

                  {/* Change Wallet Button with Icon */}
                  <button
                    onClick={() => console.log('Change wallet clicked')}
                    className="absolute hover:opacity-80 transition-opacity flex items-center justify-center"
                    style={{
                      width: 'clamp(37.5px, 3.91vw, 75px)',
                      height: 'clamp(17.5px, 1.82vw, 35px)',
                      left: 'clamp(142px, 14.79vw, 284px)',
                      top: 'clamp(18.5px, 1.93vw, 37px)',
                      backgroundColor: 'rgba(87, 191, 80, 0.4)',
                      border: '1px solid #51AF4B',
                      cursor: 'pointer',
                      borderRadius: '4px'
                    }}
                  >
                    <img
                      src={group45}
                      alt="Change"
                      style={{
                        width: 'clamp(9px, 0.94vw, 18px)',
                        height: 'clamp(9px, 0.94vw, 18px)'
                      }}
                    />
                  </button>
                </div>

                {/* Bio Section - RIGHT BOTTOM */}
                <div 
                  className="absolute border"
                  style={{
                    width: 'clamp(200px, 20.83vw, 400px)',
                    height: 'clamp(120px, 12.5vw, 240px)',
                    left: 'clamp(289px, 30.1vw, 578px)',
                    marginTop: 'clamp(10px, 1.04vw, 20px)',
                    backgroundColor: '#212121',
                    borderColor: '#8F0A0A',
                    border: '1px solid #8F0A0A',
                    borderBottom: 'none',
                    borderTopLeftRadius: '6px',
                    borderTopRightRadius: '6px'
                  }}
                >
                  {/* Bio Label */}
                  <div
                    style={{
                      position: 'absolute',
                      left: 'clamp(26.5px, 2.76vw, 53px)',
                      top: 'clamp(7px, 0.73vw, 14px)',
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(7px, 0.73vw, 14px)',
                      color: 'rgba(255, 255, 255, 0.6)'
                    }}
                  >
                    Bio
                  </div>

                  {/* Bio Text Container */}
                  <div
                    className="absolute border"
                    style={{
                      width: 'clamp(120px, 12.5vw, 240px)',
                      height: 'clamp(93.75px, 9.37vw, 180px)',
                      left: 'clamp(19.8px, 1.98vw, 38px)',
                      top: 'clamp(18.75px, 1.87vw, 36px)',
                      backgroundColor: '#191919',
                      borderColor: '#790E0E',
                      padding: 'clamp(7px, 0.73vw, 14px)',
                      borderRadius: '4px'
                    }}
                  >
                    {/* Bio Content */}
                    <div
                      style={{
                        width: '100%',
                        height: '100%',
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(7px, 0.73vw, 14px)',
                        color: 'rgba(255, 255, 255, 0.8)',
                        lineHeight: '1.4',
                        overflow: 'hidden',
                        display: '-webkit-box',
                        WebkitLineClamp: 5, // уменьшено количество строк
                        WebkitBoxOrient: 'vertical',
                        wordBreak: 'break-word',
                        whiteSpace: 'normal'
                      }}
                    >
                      {user?.bio || ''}
                    </div>

                    {/* Done Icon for Bio */}
                    <img
                      src={icondone}
                      alt="Done"
                      style={{
                        position: 'absolute',
                        width: 'clamp(9px, 0.94vw, 18px)',
                        height: 'clamp(9px, 0.94vw, 18px)',
                        right: 'clamp(7px, 0.73vw, 14px)',
                        bottom: 'clamp(7px, 0.73vw, 14px)'
                      }}
                    />
                  </div>

                  {/* Change Bio Button */}
                  <button
                    onClick={() => setIsBioModalOpen(true)}
                    className="absolute hover:opacity-80 transition-opacity"
                    style={{
                      width: 'clamp(37.5px, 3.91vw, 75px)',
                      height: 'clamp(17.5px, 1.82vw, 35px)',
                      left: 'clamp(150.5px, 15.1vw, 290px)',
                      top: 'clamp(18.75px, 1.87vw, 36px)',
                      backgroundColor: '#5492E8',
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(6px, 0.62vw, 12px)',
                      color: '#FFFFFF',
                      border: 'none',
                      cursor: 'pointer',
                      borderRadius: '4px'
                    }}
                  >
                    Change
                  </button>
                </div>

                {/* Instagram Verification Section - RIGHT BOTTOM BOTTOM */}
                <div
                  className="absolute border"
                  style={{
                    width: 'clamp(200px, 20.83vw, 400px)',
                    height: 'clamp(55.5px, 5.78vw, 111px)',
                    left: 'clamp(289px, 30.1vw, 578px)',
                    top: 'clamp(190px, 19.79vw, 380px)',
                    backgroundColor: '#191919',
                    borderColor: '#790E0E',
                    border: '1px solid #790E0E',
                    borderBottomLeftRadius: '6px',
                    borderBottomRightRadius: '6px'
                  }}
                >
                  {/* Instagram Verification Label */}
                  <div
                    style={{
                      position: 'absolute',
                      left: 'clamp(22.5px, 2.34vw, 45px)',
                      top: 'clamp(9px, 0.94vw, 18px)',
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(7px, 0.73vw, 14px)',
                      color: 'rgba(255, 255, 255, 0.6)'
                    }}
                  >
                    Instagram Verification
                  </div>

                  {/* Instagram Input Container */}
                  <div
                    className="absolute border"
                    style={{
                      width: 'clamp(120px, 12.5vw, 240px)',
                      height: 'clamp(17.5px, 1.82vw, 35px)',
                      left: 'clamp(15px, 1.56vw, 30px)',
                      top: 'clamp(19.5px, 2.03vw, 39px)',
                      backgroundColor: '#191919',
                      borderColor: '#790E0E',
                      borderRadius: '4px'
                    }}
                  >
                    {/* Instagram Icon Container */}
                    <div
                      className="absolute flex items-center justify-center"
                      style={{
                        width: 'clamp(15px, 1.56vw, 30px)',
                        height: 'clamp(15.5px, 1.72vw, 33px)',
                        left: '0',
                        top: '0',
                        backgroundColor: '#790E0E'
                      }}
                    >
                      <img
                        src={instagram_icon}
                        alt="Instagram"
                        style={{
                          width: 'clamp(7px, 0.73vw, 14px)',
                          height: 'clamp(7px, 0.73vw, 14px)'
                        }}
                      />
                    </div>

                    {/* Instagram Text */}
                    <div
                      className="absolute flex items-center"
                      style={{
                        left: 'clamp(21.5px, 2.24vw, 43px)',
                        right: 'clamp(20px, 2.08vw, 40px)',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(6px, 0.62vw, 12px)',
                        color: 'rgba(255, 255, 255, 0.8)',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      {user?.instagram || ''}
                    </div>

                    {/* Done Icon */}
                    {user?.instagram && (
                      <img
                        src={icondone}
                        alt="Done"
                        style={{
                          position: 'absolute',
                          width: 'clamp(9px, 0.94vw, 18px)',
                          height: 'clamp(9px, 0.94vw, 18px)',
                          right: 'clamp(5px, 0.52vw, 10px)',
                          top: '50%',
                          transform: 'translateY(-50%)'
                        }}
                      />
                    )}
                  </div>

                  {/* Request Button */}
                  <button
                    onClick={() => console.log('Request verification clicked')}
                    className="absolute hover:opacity-80 transition-opacity"
                    style={{
                      width: 'clamp(37.5px, 3.91vw, 75px)',
                      height: 'clamp(17.5px, 1.82vw, 35px)',
                      left: 'clamp(141.5px, 14.74vw, 283px)',
                      top: 'clamp(19.5px, 2.03vw, 39px)',
                      backgroundColor: '#5492E8',
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(6px, 0.62vw, 12px)',
                      color: '#FFFFFF',
                      border: 'none',
                      cursor: 'pointer',
                      borderRadius: '4px'
                    }}
                  >
                    Request
                  </button>

                  {/* Warning Icon + Need to verify instagram text */}
                  <div
                    className="absolute flex items-center gap-1"
                    style={{
                      left: 'clamp(23px, 2.4vw, 46px)',
                      top: 'clamp(38.5px, 4.01vw, 77px)'
                    }}
                  >
                    <img
                      src={warning_sign}
                      alt="Warning"
                      style={{
                        width: 'clamp(7px, 0.73vw, 14px)',
                        height: 'clamp(7px, 0.73vw, 14px)'
                      }}
                    />
                    <div
                      style={{
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(5px, 0.52vw, 10px)',
                        color: 'rgba(255, 255, 255, 0.8)'
                      }}
                    >
                      Need to verify instagram account
                    </div>
                  </div>
                </div>

                {/* Creator Account Request Section - RIGHT TOP */}
                <div 
                  className="absolute border"
                  style={{
                    width: 'clamp(261px, 27.19vw, 522px)',
                    height: 'clamp(55.5px, 5.78vw, 111px)',
                    left: 'clamp(552px, 57.5vw, 1104px)',
                    top: 'clamp(15px, 1.67vw, 30px)',
                    backgroundColor: '#191919',
                    border: '1px solid #790E0E',
                    borderRadius: '6px'
                  }}
                >
                  {/* Creator Account Button */}
                  <button
                    className="absolute hover:opacity-80 transition-opacity"
                    style={{
                      width: 'clamp(95px, 9.9vw, 190px)',
                      height: 'clamp(17.5px, 1.82vw, 35px)',
                      left: 'clamp(14px, 1.46vw, 28px)',
                      top: 'clamp(19px, 1.98vw, 38px)',
                      backgroundColor: 'rgba(109, 255, 102, 0.8)',
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(8px, 0.83vw, 16px)',
                      color: '#FFFFFF',
                      border: 'none',
                      cursor: 'pointer',
                      borderRadius: '4px'
                    }}
                  >
                    Creator Account
                  </button>

                  {/* Right Text Block with Left Border */}
                  <div
                    className="absolute"
                    style={{
                      width: 'clamp(140px, 14.58vw, 280px)',
                      height: '100%',
                      right: '0',
                      top: '0',
                      backgroundColor: '#191919',
                      borderLeft: '1px solid #790E0E',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: 'clamp(10px, 1.04vw, 20px)'
                    }}
                  >
                    <div
                      style={{
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(7px, 0.73vw, 14px)',
                        color: 'rgba(255, 255, 255, 0.8)',
                        textAlign: 'center',
                        lineHeight: '1.4'
                      }}
                    >
                      To be capable mint your own collection you need to send request to change your account status to "Creator".
                    </div>
                  </div>
                </div>

                {/* Creator Account Conditions Section - RIGHT BOTTOM */}
                <div 
                  className="absolute border"
                  style={{
                    width: 'clamp(195px, 20.31vw, 390px)',
                    height: 'clamp(155px, 16.15vw, 310px)',
                    left: 'clamp(552px, 57.5vw, 1104px)',
                    marginTop: 'clamp(20px, 1.54vw, 30px)',
                    backgroundColor: '#212121',
                    border: '1px solid #8F0A0A',
                    borderRadius: '6px'
                  }}
                >
                  {/* Title */}
                  <div
                    style={{
                      position: 'absolute',
                      left: 'clamp(26.5px, 2.76vw, 53px)',
                      top: 'clamp(7px, 0.73vw, 14px)',
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(7px, 0.73vw, 14px)',
                      color: 'rgba(255, 255, 255, 0.6)'
                    }}
                  >
                    Creator Account Conditions
                  </div>

                  {/* Email Verification Block - Green */}
                  <div
                    className="absolute border"
                    style={{
                      width: 'clamp(110px, 11.46vw, 220px)',
                      height: 'clamp(15px, 1.56vw, 30px)',
                      left: 'clamp(20.5px, 2.14vw, 41px)',
                      top: 'clamp(19.5px, 2.03vw, 39px)',
                      backgroundColor: 'transparent',
                      borderColor: '#43853F',
                      borderRadius: '4px'
                    }}
                  >
                    <div
                      style={{
                        position: 'absolute',
                        left: 'clamp(8px, 0.83vw, 16px)',
                        top: 'clamp(3.5px, 0.36vw, 7px)',
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(6px, 0.62vw, 12px)',
                        color: 'rgba(255, 255, 255, 0.8)'
                      }}
                    >
                      Email Verification
                    </div>
                    <div
                      className="absolute flex items-center justify-center"
                      style={{
                        width: 'clamp(15px, 1.56vw, 30px)',
                        height: 'clamp(15px, 1.56vw, 30px)',
                        right: '0',
                        top: '0',
                        backgroundColor: '#43853F'
                      }}
                    >
                      <img
                        src={group45}
                        alt="Done"
                        style={{
                          width: 'clamp(9px, 0.94vw, 18px)',
                          height: 'clamp(9px, 0.94vw, 18px)'
                        }}
                      />
                    </div>
                  </div>

                  {/* Question Icon for Email */}
                  <img
                    src={question}
                    alt="Question"
                    style={{
                      position: 'absolute',
                      width: 'clamp(9px, 0.94vw, 18px)',
                      height: 'clamp(9px, 0.94vw, 18px)',
                      left: 'clamp(135.5px, 14.11vw, 271px)',
                      top: 'clamp(22.5px, 2.34vw, 45px)'
                    }}
                  />

                  {/* Instagram Verification Block - Red */}
                  <div
                    className="absolute border"
                    style={{
                      width: 'clamp(110px, 11.46vw, 220px)',
                      height: 'clamp(15px, 1.56vw, 30px)',
                      left: 'clamp(20.5px, 2.14vw, 41px)',
                      top: 'clamp(38.5px, 4.01vw, 77px)',
                      backgroundColor: 'transparent',
                      borderColor: '#790E0E',
                      borderRadius: '4px'
                    }}
                  >
                    <div
                      style={{
                        position: 'absolute',
                        left: 'clamp(8px, 0.83vw, 16px)',
                        top: 'clamp(3.5px, 0.36vw, 7px)',
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(6px, 0.62vw, 12px)',
                        color: 'rgba(255, 255, 255, 0.8)'
                      }}
                    >
                      Instagram Verification
                    </div>
                    <div
                      className="absolute flex items-center justify-center"
                      style={{
                        width: 'clamp(15px, 1.56vw, 30px)',
                        height: 'clamp(15px, 1.56vw, 30px)',
                        right: '0',
                        top: '0',
                        backgroundColor: '#790E0E'
                      }}
                    >
                      <img
                        src={group76}
                        alt="Lock"
                        style={{
                          width: 'clamp(8.5px, 0.89vw, 17px)',
                          height: 'clamp(8.5px, 0.89vw, 17px)'
                        }}
                      />
                    </div>
                  </div>

                  {/* Question Icon for Instagram */}
                  <img
                    src={question}
                    alt="Question"
                    style={{
                      position: 'absolute',
                      width: 'clamp(9px, 0.94vw, 18px)',
                      height: 'clamp(9px, 0.94vw, 18px)',
                      left: 'clamp(135.5px, 14.11vw, 271px)',
                      top: 'clamp(41.5px, 4.32vw, 83px)'
                    }}
                  />

                  {/* Moderation Approve Block - Red */}
                  <div
                    className="absolute border"
                    style={{
                      width: 'clamp(110px, 11.46vw, 220px)',
                      height: 'clamp(15px, 1.56vw, 30px)',
                      left: 'clamp(20.5px, 2.14vw, 41px)',
                      top: 'clamp(57.5px, 5.99vw, 115px)',
                      backgroundColor: 'transparent',
                      borderColor: '#790E0E',
                      borderRadius: '4px'
                    }}
                  >
                    <div
                      style={{
                        position: 'absolute',
                        left: 'clamp(8px, 0.83vw, 16px)',
                        top: 'clamp(3.5px, 0.36vw, 7px)',
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(6px, 0.62vw, 12px)',
                        color: 'rgba(255, 255, 255, 0.8)'
                      }}
                    >
                      Moderation Approve
                    </div>
                    <div
                      className="absolute flex items-center justify-center"
                      style={{
                        width: 'clamp(15px, 1.56vw, 30px)',
                        height: 'clamp(15px, 1.56vw, 30px)',
                        right: '0',
                        top: '0',
                        backgroundColor: '#790E0E'
                      }}
                    >
                      <img
                        src={group76}
                        alt="Lock"
                        style={{
                          width: 'clamp(8.5px, 0.89vw, 17px)',
                          height: 'clamp(8.5px, 0.89vw, 17px)'
                        }}
                      />
                    </div>
                  </div>

                  {/* Question Icon for Moderation */}
                  <img
                    src={question}
                    alt="Question"
                    style={{
                      position: 'absolute',
                      width: 'clamp(9px, 0.94vw, 18px)',
                      height: 'clamp(9px, 0.94vw, 18px)',
                      left: 'clamp(135.5px, 14.11vw, 271px)',
                      top: 'clamp(60.5px, 6.3vw, 121px)'
                    }}
                  />

                  {/* Wallet Connection Block - Red */}
                  <div
                    className="absolute border"
                    style={{
                      width: 'clamp(110px, 11.46vw, 220px)',
                      height: 'clamp(15px, 1.56vw, 30px)',
                      left: 'clamp(20.5px, 2.14vw, 41px)',
                      top: 'clamp(76.5px, 7.97vw, 153px)',
                      backgroundColor: 'transparent',
                      borderColor: '#790E0E',
                      borderRadius: '4px'
                    }}
                  >
                    <div
                      style={{
                        position: 'absolute',
                        left: 'clamp(8px, 0.83vw, 16px)',
                        top: 'clamp(3.5px, 0.36vw, 7px)',
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(6px, 0.62vw, 12px)',
                        color: 'rgba(255, 255, 255, 0.8)'
                      }}
                    >
                      Wallet Connection
                    </div>
                    <div
                      className="absolute flex items-center justify-center"
                      style={{
                        width: 'clamp(15px, 1.56vw, 30px)',
                        height: 'clamp(15px, 1.56vw, 30px)',
                        right: '0',
                        top: '0',
                        backgroundColor: '#790E0E'
                      }}
                    >
                      <img
                        src={group76}
                        alt="Lock"
                        style={{
                          width: 'clamp(8.5px, 0.89vw, 17px)',
                          height: 'clamp(8.5px, 0.89vw, 17px)'
                        }}
                      />
                    </div>
                  </div>

                  {/* Question Icon for Wallet */}
                  <img
                    src={question}
                    alt="Question"
                    style={{
                      position: 'absolute',
                      width: 'clamp(9px, 0.94vw, 18px)',
                      height: 'clamp(9px, 0.94vw, 18px)',
                      left: 'clamp(135.5px, 14.11vw, 271px)',
                      top: 'clamp(79.5px, 8.28vw, 159px)'
                    }}
                  />

                  {/* Note Section at Bottom */}
                  <div
                    className="absolute"
                    style={{
                      width: '100%',
                      height: 'clamp(53.5px, 5.57vw, 107px)',
                      left: '0',
                      bottom: '0',
                      backgroundColor: '#191919',
                      borderTop: '1px solid #790E0E'
                    }}
                  >
                    {/* Note: Label */}
                    <div
                      style={{
                        position: 'absolute',
                        left: 'clamp(11.5px, 1.2vw, 23px)',
                        top: 'clamp(4.5px, 0.47vw, 9px)',
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(6px, 0.62vw, 12px)',
                        color: 'rgba(255, 255, 255, 0.9)'
                      }}
                    >
                      Note:
                    </div>

                    {/* Note Text */}
                    <div
                      style={{
                        position: 'absolute',
                        left: 'clamp(11.5px, 1.2vw, 23px)',
                        top: 'clamp(14px, 1.46vw, 28px)',
                        right: 'clamp(11.5px, 1.2vw, 23px)',
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(6px, 0.62vw, 12px)',
                        color: 'rgba(255, 255, 255, 0.6)',
                        lineHeight: '1.4'
                      }}
                    >
                      Make sure you did all necessary steps to start your creator journey on Sewing Factory. Be mindful about our rules and remember that we have careful attitude to each artist and collector in order to do great place for digital art.
                    </div>
                  </div>
                </div>

                {/* Social Media Section - LEFT SIDE */}
                <div 
                  className="relative border"
                  style={{
                    width: 'clamp(200px, 20.83vw, 400px)',
                    height: 'clamp(122px, 13.04vw, 244px)',
                    marginLeft: 'clamp(51.5px, 5.36vw, 103px)',
                    marginTop: 'clamp(10px, 1.04vw, 20px)',
                    backgroundColor: '#212121',
                    borderColor: '#8F0A0A',
                    border: '1px solid #790E0E',
                    borderTopLeftRadius: '6px',
                    borderTopRightRadius: '6px'
                  }}
                >
                  {/* Instagram Section */}
                  <div>
                    {/* Instagram Label */}
                    <div
                      style={{
                        position: 'absolute',
                        left: 'clamp(22.5px, 2.34vw, 45px)',
                        top: 'clamp(9.5px, 0.99vw, 19px)',
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(7px, 0.73vw, 14px)',
                        color: 'rgba(255, 255, 255, 0.6)'
                      }}
                    >
                      Instagram
                    </div>

                    {/* Instagram Input Container */}
                    <div
                      className="absolute border"
                      style={{
                        width: 'clamp(120px, 12.5vw, 240px)',
                        height: 'clamp(17.5px, 1.82vw, 35px)',
                        left: 'clamp(15px, 1.56vw, 30px)',
                        top: 'clamp(20px, 2.08vw, 40px)',
                        backgroundColor: '#191919',
                        borderColor: '#790E0E',
                        borderRadius: '4px'
                      }}
                    >
                      {/* Instagram Icon Container */}
                      <div
                        className="absolute flex items-center justify-center"
                        style={{
                          width: 'clamp(15px, 1.56vw, 30px)',
                          height: 'clamp(15.5px, 1.72vw, 33px)',
                          left: '0',
                          top: '0',
                          backgroundColor: '#790E0E'
                        }}
                      >
                        <img
                          src={instagram_icon}
                          alt="Instagram"
                          style={{
                            width: 'clamp(7px, 0.73vw, 14px)',
                            height: 'clamp(7px, 0.73vw, 14px)'
                          }}
                        />
                      </div>

                      {/* Instagram Text */}
                      <div
                        className="absolute flex items-center"
                        style={{
                          left: 'clamp(21.5px, 2.24vw, 43px)',
                          right: 'clamp(20px, 2.08vw, 40px)',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          fontFamily: 'Keania One',
                          fontWeight: 400,
                          fontSize: 'clamp(6px, 0.62vw, 12px)',
                          color: 'rgba(255, 255, 255, 0.8)',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        {user?.instagram || ''}
                      </div>

                      {/* Done Icon */}
                      {user?.instagram && (
                        <img
                          src={icondone}
                          alt="Done"
                          style={{
                            position: 'absolute',
                            width: 'clamp(9px, 0.94vw, 18px)',
                            height: 'clamp(9px, 0.94vw, 18px)',
                            right: 'clamp(5px, 0.52vw, 10px)',
                            top: '50%',
                            transform: 'translateY(-50%)'
                          }}
                        />
                      )}
                    </div>

                    {/* Add Instagram Button */}
                    <button
                      onClick={() => setIsInstagramModalOpen(true)}
                      className="absolute hover:opacity-80 transition-opacity"
                      style={{
                        width: 'clamp(37.5px, 3.91vw, 75px)',
                        height: 'clamp(17.5px, 1.82vw, 35px)',
                        left: 'clamp(141.5px, 14.74vw, 283px)',
                        top: 'clamp(20px, 2.08vw, 40px)',
                        backgroundColor: '#5492E8',
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(6px, 0.62vw, 12px)',
                        color: '#FFFFFF',
                        border: 'none',
                        cursor: 'pointer',
                        borderRadius: '4px'
                      }}
                    >
                      Add
                    </button>
                  </div>

                  {/* Twitter Section */}
                  <div>
                    {/* Twitter Label */}
                    <div
                      className="flex items-center gap-1"
                      style={{
                        position: 'absolute',
                        left: 'clamp(22.5px, 2.34vw, 45px)',
                        top: 'clamp(44px, 4.58vw, 88px)',
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(7px, 0.73vw, 14px)',
                        color: 'rgba(255, 255, 255, 0.6)'
                      }}
                    >
                      Account on
                      <img
                        src={twitter1}
                        alt="Twitter"
                        style={{
                          width: 'clamp(6px, 0.62vw, 12px)',
                          height: 'clamp(6px, 0.62vw, 12px)',
                          marginLeft: '4px'
                        }}
                      />
                    </div>

                    {/* Twitter Input Container */}
                    <div
                      className="absolute border"
                      style={{
                        width: 'clamp(120px, 12.5vw, 240px)',
                        height: 'clamp(17.5px, 1.82vw, 35px)',
                        left: 'clamp(15px, 1.56vw, 30px)',
                        top: 'clamp(54px, 5.62vw, 108px)',
                        backgroundColor: '#191919',
                        borderColor: '#790E0E',
                        borderRadius: '4px'
                      }}
                    >
                      {/* Twitter Icon Container */}
                      <div
                        className="absolute flex items-center justify-center"
                        style={{
                          width: 'clamp(15px, 1.56vw, 30px)',
                          height: 'clamp(15.5px, 1.72vw, 33px)',
                          left: '0',
                          top: '0',
                          backgroundColor: '#790E0E'
                        }}
                      >
                        <img
                          src={twitter2}
                          alt="Twitter"
                          style={{
                            width: 'clamp(7px, 0.73vw, 14px)',
                            height: 'clamp(7px, 0.73vw, 14px)'
                          }}
                        />
                      </div>

                      {/* Twitter Text */}
                      <div
                        className="absolute flex items-center"
                        style={{
                          left: 'clamp(21.5px, 2.24vw, 43px)',
                          right: 'clamp(20px, 2.08vw, 40px)',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          fontFamily: 'Keania One',
                          fontWeight: 400,
                          fontSize: 'clamp(6px, 0.62vw, 12px)',
                          color: 'rgba(255, 255, 255, 0.8)',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        {user?.twitter || ''}
                      </div>

                      {/* Done Icon */}
                      {user?.twitter && (
                        <img
                          src={icondone}
                          alt="Done"
                          style={{
                            position: 'absolute',
                            width: 'clamp(9px, 0.94vw, 18px)',
                            height: 'clamp(9px, 0.94vw, 18px)',
                            right: 'clamp(5px, 0.52vw, 10px)',
                            top: '50%',
                            transform: 'translateY(-50%)'
                          }}
                        />
                      )}
                    </div>

                    {/* Add Twitter Button */}
                    <button
                      onClick={() => setIsTwitterModalOpen(true)}
                      className="absolute hover:opacity-80 transition-opacity"
                      style={{
                        width: 'clamp(37.5px, 3.91vw, 75px)',
                        height: 'clamp(17.5px, 1.82vw, 35px)',
                        left: 'clamp(141.5px, 14.74vw, 283px)',
                        top: 'clamp(54px, 5.62vw, 108px)',
                        backgroundColor: '#5492E8',
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(6px, 0.62vw, 12px)',
                        color: '#FFFFFF',
                        border: 'none',
                        cursor: 'pointer',
                        borderRadius: '4px'
                      }}
                    >
                      Add
                    </button>
                  </div>

                  {/* Discord Section */}
                  <div>
                    {/* Discord Label */}
                    <div
                      style={{
                        position: 'absolute',
                        left: 'clamp(22.5px, 2.34vw, 45px)',
                        top: 'clamp(78px, 8.12vw, 156px)',
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(7px, 0.73vw, 14px)',
                        color: 'rgba(255, 255, 255, 0.6)'
                      }}
                    >
                      Discord
                    </div>

                    {/* Discord Input Container */}
                    <div
                      className="absolute border"
                      style={{
                        width: 'clamp(120px, 12.5vw, 240px)',
                        height: 'clamp(17.5px, 1.82vw, 35px)',
                        left: 'clamp(15px, 1.56vw, 30px)',
                        top: 'clamp(88px, 9.17vw, 176px)',
                        backgroundColor: '#191919',
                        borderColor: '#790E0E',
                        borderRadius: '4px'
                      }}
                    >
                      {/* Discord Icon Container */}
                      <div
                        className="absolute flex items-center justify-center"
                        style={{
                          width: 'clamp(15px, 1.56vw, 30px)',
                          height: 'clamp(15.5px, 1.72vw, 33px)',
                          left: '0',
                          top: '0',
                          backgroundColor: '#790E0E'
                        }}
                      >
                        <img
                          src={discord_icon}
                          alt="Discord"
                          style={{
                            width: 'clamp(7px, 0.73vw, 14px)',
                            height: 'clamp(7px, 0.73vw, 14px)'
                          }}
                        />
                      </div>

                      {/* Discord Text */}
                      <div
                        className="absolute flex items-center"
                        style={{
                          left: 'clamp(21.5px, 2.24vw, 43px)',
                          right: 'clamp(20px, 2.08vw, 40px)',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          fontFamily: 'Keania One',
                          fontWeight: 400,
                          fontSize: 'clamp(6px, 0.62vw, 12px)',
                          color: 'rgba(255, 255, 255, 0.8)',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap'
                          }}
                          >
                          {user?.discord || ''}
                      </div>

                      {/* Done Icon */}
                      {user?.discord && (
                        <img
                          src={icondone}
                          alt="Done"
                          style={{
                            position: 'absolute',
                            width: 'clamp(9px, 0.94vw, 18px)',
                            height: 'clamp(9px, 0.94vw, 18px)',
                            right: 'clamp(5px, 0.52vw, 10px)',
                            top: '50%',
                            transform: 'translateY(-50%)'
                          }}
                        />
                      )}
                    </div>

                    {/* Add Discord Button */}
                    <button
                      onClick={() => setIsDiscordModalOpen(true)}
                      className="absolute hover:opacity-80 transition-opacity"
                      style={{
                        width: 'clamp(37.5px, 3.91vw, 75px)',
                        height: 'clamp(17.5px, 1.82vw, 35px)',
                        left: 'clamp(141.5px, 14.74vw, 283px)',
                        top: 'clamp(88px, 9.17vw, 176px)',
                        backgroundColor: '#5492E8',
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(6px, 0.62vw, 12px)',
                        color: '#FFFFFF',
                        border: 'none',
                        cursor: 'pointer',
                        borderRadius: '4px'
                      }}
                    >
                      Add
                    </button>
                  </div>
                </div>

                {/* Email Verification Section - LEFT SIDE */}
                <div
                  className="absolute"
                  style={{
                    width: 'clamp(200px, 20.83vw, 400px)',
                    height: 'clamp(55.5px, 5.78vw, 111px)',
                    marginLeft: 'clamp(51.5px, 5.36vw, 103px)',
                    top: 'clamp(200px, 20.44vw, 400px)',
                    backgroundColor: '#191919',
                    border: '1px solid #790E0E',
                    borderTop: 'none',
                    borderBottomLeftRadius: '6px',
                    borderBottomRightRadius: '6px'
                  }}
                >
                {/* Email Label */}
                <div
                  style={{
                    position: 'absolute',
                    left: 'clamp(22.5px, 2.34vw, 45px)',
                    top: 'clamp(9px, 0.94vw, 18px)',
                    fontFamily: 'Keania One',
                    fontWeight: 400,
                    fontSize: 'clamp(7px, 0.73vw, 14px)',
                    color: 'rgba(255, 255, 255, 0.6)'
                  }}
                >
                  Email
                </div>

                {/* Email Input Container */}
                <div
                  className="absolute border"
                  style={{
                    width: 'clamp(120px, 12.5vw, 240px)',
                    height: 'clamp(17.5px, 1.82vw, 35px)',
                    left: 'clamp(15px, 1.56vw, 30px)',
                    top: 'clamp(19.5px, 2.03vw, 39px)',
                    backgroundColor: '#191919',
                    borderColor: '#790E0E',
                    borderRadius: '4px'
                  }}
                >
                  {/* Email Icon Container */}
                  <div
                    className="absolute flex items-center justify-center"
                    style={{
                      width: 'clamp(15px, 1.56vw, 30px)',
                      height: 'clamp(15.5px, 1.72vw, 33px)',
                      left: '0',
                      top: '0',
                      backgroundColor: '#790E0E'
                    }}
                  >
                    <img
                      src={mail2}
                      alt="Email"
                      style={{
                        width: 'clamp(7px, 0.73vw, 14px)',
                        height: 'clamp(7px, 0.73vw, 14px)'
                      }}
                    />
                  </div>

                  {/* Email Text */}
                  <div
                    className="absolute flex items-center"
                    style={{
                      left: 'clamp(21.5px, 2.24vw, 43px)',
                      right: 'clamp(20px, 2.08vw, 40px)',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(6px, 0.62vw, 12px)',
                      color: 'rgba(255, 255, 255, 0.8)',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {user?.email || ''}
                  </div>

                  {/* Done Icon */}
                  {user?.email && (
                    <img
                      src={icondone}
                      alt="Done"
                      style={{
                        position: 'absolute',
                        width: 'clamp(9px, 0.94vw, 18px)',
                        height: 'clamp(9px, 0.94vw, 18px)',
                        right: 'clamp(5px, 0.52vw, 10px)',
                        top: '50%',
                        transform: 'translateY(-50%)'
                      }}
                    />
                  )}
                </div>

                {/* Verify Button */}
                <button
                  onClick={() => console.log('Verify email clicked')}
                  className="absolute hover:opacity-80 transition-opacity"
                  style={{
                    width: 'clamp(35px, 3.65vw, 70px)',
                    height: 'clamp(17.5px, 1.82vw, 35px)',
                    left: 'clamp(141.5px, 14.74vw, 283px)',
                    top: 'clamp(19.5px, 2.03vw, 39px)',
                    backgroundColor: '#52C04D',
                    fontFamily: 'Keania One',
                    fontWeight: 400,
                    fontSize: 'clamp(6px, 0.62vw, 12px)',
                    color: '#FFFFFF',
                    border: 'none',
                    cursor: 'pointer',
                    borderRadius: '4px'
                  }}
                >
                  Verify
                </button>

                {/* Warning Icon + Need to verify text */}
                <div
                  className="absolute flex items-center gap-1"
                  style={{
                    left: 'clamp(23px, 2.4vw, 46px)',
                    top: 'clamp(38.5px, 4.01vw, 77px)'
                  }}
                >
                  <img
                    src={warning_sign}
                    alt="Warning"
                    style={{
                      width: 'clamp(7px, 0.73vw, 14px)',
                      height: 'clamp(7px, 0.73vw, 14px)'
                    }}
                  />
                  <div
                    style={{
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(5px, 0.52vw, 10px)',
                      color: 'rgba(255, 255, 255, 0.8)'
                    }}
                  >
                    Need to verify email address
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
          <Footer />
        </main>
      </div>
    </div>
  );
}
